import React from "react";
import {
  criarTipoProtocoloDs,
  criarSetorAtendimentoProtocoloDs,
} from "../../DataSources.js";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import Memoria from "../../Memoria";
import notify from "devextreme/ui/notify";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import apiAxios from "../../api-axios";
import HtmlEditor, {
  Toolbar,
  Item,
  MediaResizing,
} from "devextreme-react/html-editor";
import { markup } from "../../data-markup.js";
import CheckBox from "devextreme-react/check-box";
import ShowError from "../../AppServices.js";

const template = {
  prefeituraId: UserInfo.getPrefeitura(),
  nome: "",
  setorId: undefined,
  avisoPrefeitura: "",
};

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

const sizeValues = ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"];
const fontValues = ["Arial", "Georgia", "Tahoma", "Times New Roman", "Verdana"];
const headerValues = [false, 1, 2, 3, 4, 5];

export default class TipoProtocoloForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...(_cadastroCorrente || template),
      setores: {},
      avisoPrefeitura: "",
    };
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.tipoProtocoloDs = criarTipoProtocoloDs();
    this.htmlEditorField = React.createRef();
    this.valueChangedOnText = this.valueChangedOnText.bind(this);

    this.setorOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "Escolher...",
      valueExpr: "sequencial",
      displayExpr: "nome",
      /* dataSource: criarSetorAtendimentoProtocoloDs() */
    };
  }

  async componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.tipoProtocoloDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data == undefined) {
            notify("Registro não encontrado.", "error");
            this.props.history.push("/tipoprotocolo");
          }

          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    const response = await apiAxios.get(
      "protocolos/setores/prefeitura/" + UserInfo.getPrefeitura()
    );
    this.setState({ setores: response.data.data });
  }

  valueChangedOnText(e) {
    this.setState({
      avisoPrefeitura: e.target.innerHTML,
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2}>
              <GroupItem
                caption="DADOS DO TIPO DE PROTOCOLO"
                colSpan={2}
                colCount={4}
              >
                <SimpleItem colSpan={2} dataField={"nome"} />
                <SimpleItem
                  colSpan={2}
                  dataField={"setorId"}
                  editorType={"dxLookup"}
                  editorOptions={{
                    ...this.setorOptions,
                    items: this.state.setores,
                  }}
                >
                  <Label text="Setor" />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption="TEXTO" colSpan={2}>
                <HtmlEditor
                  ref={this.htmlEditorField}
                  height={"300px"}
                  mediaResizing={{ enabled: true }}
                  value={this.state.avisoPrefeitura}
                  onFocusOut={({ event }) => this.valueChangedOnText(event)}
                >
                  <Toolbar>
                    <Item formatName="undo" />
                    <Item formatName="redo" />
                    <Item formatName="separator" />
                    <Item
                      formatName="size"
                      formatValues={[
                        "8pt",
                        "10pt",
                        "12pt",
                        "14pt",
                        "18pt",
                        "24pt",
                        "36pt",
                      ]}
                    />
                    <Item
                      formatName="font"
                      formatValues={[
                        "Arial",
                        "Courier New",
                        "Georgia",
                        "Impact",
                        "Lucida Console",
                        "Tahoma",
                        "Times New Roman",
                        "Verdana",
                      ]}
                    />
                    <Item formatName="separator" />
                    <Item formatName="bold" />
                    <Item formatName="italic" />
                    <Item formatName="strike" />
                    <Item formatName="underline" />
                    <Item formatName="separator" />
                    <Item formatName="alignLeft" />
                    <Item formatName="alignCenter" />
                    <Item formatName="alignRight" />
                    <Item formatName="alignJustify" />
                    <Item formatName="separator" />
                    <Item
                      formatName="header"
                      formatValues={[false, 1, 2, 3, 4, 5]}
                    />
                    <Item formatName="separator" />
                    <Item formatName="orderedList" />
                    <Item formatName="bulletList" />
                    <Item formatName="separator" />
                    <Item formatName="color" />
                    <Item formatName="background" />
                    <Item formatName="separator" />
                    <Item formatName="link" />
                    <Item formatName="image" />
                    <Item formatName="separator" />
                    <Item formatName="clear" />
                    <Item formatName="codeBlock" />
                    <Item formatName="blockquote" />
                  </Toolbar>
                </HtmlEditor>
              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }

  async ok() {
    if (UserInfo.getUsuarioId() === undefined)
      notify("Usuário precisa selecionar prefeitura!", "warning");
    else {
      try {
        const entidade = this.state;

        template.setorId = entidade.setorId;
        template.nome = entidade.nome;
        template.avisoPrefeitura = entidade.avisoPrefeitura;

        const response = await apiAxios.post(
          `protocolos/tipos_atendimento/cadastro`,
          template
        );
        if (response.status === 200) {
          notify("Tipo de Protocolo cadastrado com sucesso!", "success");
          this.props.history.push(`/tipoprotocolo`);
        }
      } catch (error) {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      }
    }
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
